/**
 * Which product this build is. The same code builds two separate apps:
 *
 *   npm run build              → MarketMapr (default, everything as before)
 *   npm run build:recmapper    → RecMapper (REACT_APP_PRODUCT=recmapper,
 *                                written to build-recmapper/)
 *
 * RecMapper is a separate product on its own server instance and database;
 * this only decides what its build shows. The server enforces the same
 * split (backend/config/product.js).
 */
export type Product = 'marketmapr' | 'recmapper';

export const PRODUCT: Product = process.env.REACT_APP_PRODUCT === 'recmapper' ? 'recmapper' : 'marketmapr';
export const IS_RECMAPPER = PRODUCT === 'recmapper';

export const BRAND = IS_RECMAPPER
  ? { name: 'RecMapper', icon: '/recmapper-icon.svg', pricingUrl: 'https://www.recmapper.com/#pricing' }
  : { name: 'MarketMapr', icon: '/marketmapr-icon-512.png', pricingUrl: 'https://www.marketmapr.com/#pricing' };

// Sidebar items a RecMapper build shows (everything else is MarketMapr-only).
export const RECMAPPER_NAV = new Set([
  'dashboard', 'projects', 'training', 'team', 'team-members', 'audit-logs', 'settings', 'admin',
]);
